import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M21.75 19.5a.75.75 0 0 1-.75.75H3a.75.75 0 1 1 0-1.5h.75v-6A.75.75 0 0 1 4.5 12h2.25a.75.75 0 0 1 .75.75v6H9V8.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v10.5H15v-15a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 .75.75v15H21a.75.75 0 0 1 .75.75"
    }, null, -1)
  ])))
}
export default { render: render }